<template>
  <div>
    <draggable class="mb-3 trash-wrapper position-relative" :list="trashed" :sort="false" group="activities"
      :class="{ trashActive: trashDragging }"
      draggable=".none"
      :swapThreshold="0.1"
      :animation="100">
      <b-icon icon="trash"></b-icon>
      <span v-for="(card, index) in trashed" :key="`trashed_${index}`" class="mr-2 trashed pointer" @click="removeFromCompleted(card)">
        <b-img fluid :src="card.image" height="32" width="32" center rounded></b-img>
      </span>
      <div class="position-absolute non-share" style="right: 0; top: 0" v-if="trashed.length">
        <b-button size="sm" variant="secondary" @click="restart">
          <b-icon icon="arrow-counterclockwise"></b-icon> Empty
        </b-button>
      </div>
    </draggable>
    <div class="row">
      <draggable class="col-md-12 pt-4" v-model="cards" :disabled="previewMode" @end="updateCardPositions">
        <draggable :list="active" :sort="false" group="activities"
          @start="onStart"
          @end="onEnd">
          <Card v-for="(card, index) in active"
            :key="`schedule_card${index}`"
            :card="card" :selected="false" />
        </draggable>
      </draggable>
    </div>

  </div>
</template>

<script>
import {
  mapState, mapGetters, mapActions, mapMutations,
} from 'vuex';
import draggable from 'vuedraggable';
import Card from '../Card.vue';

export default {
  props: {
    previewMode: {
      type: Boolean,
      required: true,
    },
  },

  components: { draggable, Card },

  mounted() {
    this.active = [...this.scheduleCards];
  },

  watch: {
    trashed() {
      this.$nextTick(() => this.updateVisualScheduleContent(true));
    },

    scheduleCards(val) {
      this.trashed = [];
      this.completedCards = [];
      this.active = [...val];
    },
  },

  data() {
    return {
      active: [],
      completedCards: [],
      trashed: [],
      trashDragging: false,
    };
  },

  computed: {
    ...mapState(['visualSchedule']),
    ...mapGetters(['scheduleCards']),

    cards: {
      get() {
        return this.visualSchedule.visual_schedule_cards_attributes;
      },
      set(val) {
        this.updateVisualSchedule({ field: 'visual_schedule_cards_attributes', value: val });
      },
    },

    displayId() {
      return this.visualSchedule.visual_schedule_display_id;
    },
  },

  methods: {
    ...mapActions(['updateCardPositions']),
    ...mapMutations(['updateVisualSchedule', 'updateVisualScheduleContent']),

    addToCompleted(card) {
      if (this.cardFinished(card)) {
        this.removeFromCompleted(card);
        return;
      }
      this.completedCards.push(card);
    },

    onStart() {
      this.trashDragging = true;
    },

    onEnd() {
      this.trashDragging = false;
    },

    removeFromCompleted(card) {
      const index = this.trashed.findIndex((c) => c.card_id === card.card_id);
      if (index !== -1) {
        this.trashed.splice(index, 1);
        this.active.push(card);
        this.active.sort((a, b) => a.position - b.position);
      }
    },

    cardFinished(card) {
      return this.completedCards.find((c) => c.card_id === card.card_id && card.position === c.position);
    },

    restart() {
      this.active = [...this.scheduleCards];
      this.trashed = [];
    },
  },
};
</script>
